import II18 from '../translate/II18';
import { emailIsValid, phoneIsValid } from './utils';

export const messageIfEmptyValue = value =>
  !value ? II18.get('error_field_is_required') : '';
export const messageIfInvalidEmail = value =>
  !emailIsValid(value) ? II18.get('INVALID_EMAIL') : '';
export const messageIfInvalidPhone = number =>
  !phoneIsValid(number) ? II18.get('INVALID_PHONE_NUMBER_SIGNME') : '';
